export default "__VITE_ASSET__DRIm4i7C__"